import React from 'react';
import { Box, Typography, Stack, IconButton } from '@mui/material';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import CustomModal from '../../CustomModal';
import Pending from '../../../assets/transaction/Pending.png';
import Copy from '../../../assets/transaction/coppy.png';
import { formatTransactionDate } from '../../../utils/formatTime';
import useLocales from '../../../hooks/useLocales';

const DetailRow = ({ label, value, showCopy }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    enqueueSnackbar('Copied to clipboard', { variant: 'success', autoHideDuration: 2000 });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 1.5,
        borderBottom: '1px solid #F4F6F8',
      }}
    >
      <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>{translate(label)}</Typography>

      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography sx={{ fontWeight: 700, fontSize: 14, textAlign: 'right' }}>{translate(value)}</Typography>

        {showCopy && (
          <IconButton size="small" onClick={() => handleCopy(value)} sx={{ color: '#F59E0B', p: 0.5 }}>
            <img src={Copy} width="18" height="18" alt="copy icon" />
          </IconButton>
        )}
      </Stack>
    </Box>
  );
};

const PendingDialog = ({ open, onClose }) => {
  const { translate } = useLocales();

  const { memberInfo, modalData } = useSelector((x) => ({
    ...x.providers,
    ...x.lookup,
    ...x.game,
    modalData: x.profile.data,
  }));

  const Content = (
    <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', mb: 10 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          mb: 3,
        }}
      >
        <Box component="img" src={Pending} alt="status" sx={{ width: 80, height: 80, mb: 1 }} />
        <Typography variant="h5" fontWeight={800}>
          Pending
        </Typography>
      </Box>

      <Stack spacing={1}>
        <DetailRow label="transaction_id" value="123123123" showCopy />
        <DetailRow label="transaction_type" value={modalData?.transaction_type || '-'} />

        <DetailRow label="Amount" value={`${modalData?.currency || ''} ${modalData?.amount || 0}`} />

        <DetailRow label="Date & Time" value={formatTransactionDate(modalData?.date)} />
      </Stack>
    </Box>
  );

  return (
    <CustomModal open={open} onClose={onClose} maxWidth="xs" hasClose={true} title="Details">
      {Content}
    </CustomModal>
  );
};

export default PendingDialog;
